import React from 'react';
import { Box, Card, CardContent, Typography, makeStyles } from '@material-ui/core';

import Logo from 'assets/images/brandLogo.png';
import PageWrapper from 'modules/layout/pageWrapper.component';
import { Container, Item } from 'common/components/grid.component';

/*
Landing page for the "Back to Sportscale" link on Auth0's password-reset confirmation.

On a phone with the app installed this URL is claimed by the Universal Link / App Link and the user
never sees this page. It renders for everyone else: desktop, app not installed, or association
verification failing. It must therefore stand on its own, and must not depend on any query
parameter -- Auth0 appends ?iss= on the self-service flow and ?email= on the invite flow, and
neither is guaranteed.
*/
const PasswordUpdatedContainer = () => {
  const classes = useStyles();

  return (
    <PageWrapper className={classes.pageWrapper}>
      <Container justify="center">
        <Item item xs={12} sm={6} style={{ textAlign: 'center' }}>
          <Card className={classes.card}>
            <CardContent className={classes.content}>
              <Box mb="2rem">
                <img src={Logo} alt="Sportscale" className={classes.logo} />
              </Box>
              <Box mb="1rem">
                <Typography variant="h6">Your password has been updated</Typography>
              </Box>
              <Typography variant="body1">Open the Sportscale app on your phone and sign in with your new password.</Typography>
            </CardContent>
          </Card>
        </Item>
      </Container>
    </PageWrapper>
  );
};

const useStyles = makeStyles(theme => ({
  pageWrapper: {
    alignSelf: 'center',
    justifyContent: 'center',
    margin: 'auto',
  },
  card: {
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    padding: theme.spacing() * 2,
  },
  content: {
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    textAlign: 'center',
  },
  logo: {
    width: '70%',
  },
}));

PasswordUpdatedContainer.propTypes = {};

export default PasswordUpdatedContainer;
